<template>
  <div class="">
    <div class="card p-5" :class="$style.container">
      <img width="231" height="48" src="../../../../assets/img/logo-istry-login.png" />

      <div class="text-dark my-3 text-left" style="font-size: 28px;">
        <strong>Hi, welcome to ISTRY</strong>
      </div>
      <div class="mb-2 text-left" style="font-size: 14px;color: #4C749F;">
        ISTRY (Indonesian Systemic Therapy) is a smart healthcare app that helps medical
        professionals easily find the right cancer treatments.
      </div>
      <a-form
        :model="resetForm"
        :rules="rules"
        layout="vertical"
        @finish="handleFinish"
        @finishFailed="handleFinishFailed"
        class="my-2"
      >
        <a-form-item name="newPassword">
          <label for="newPassword" style="color: #304E77;">New Password</label>
          <a-input-password
            v-model:value="resetForm.newPassword"
            placeholder="Input New Password"
            id="newPassword"
          />
        </a-form-item>

        <a-form-item name="confirmPassword">
          <label for="confirmPassword" style="color: #304E77;">Confirm Password</label>
          <a-input-password
            v-model:value="resetForm.confirmPassword"
            placeholder="Confirm New Password"
            id="confirmPassword"
          />
        </a-form-item>

        <a-button
          size="large"
          html-type="submit"
          class="btn w-100 d-flex align-items-center justify-content-center"
          :loading="loading"
          style="border-radius: 24px;background-color: #436894;color: white; padding-top: 30px;padding-bottom: 30px;font-size: 16px !important;"
        >
          <strong>Submit</strong>
        </a-button>
      </a-form>
    </div>
  </div>
</template>
<script>
import { reactive, ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { notification } from 'ant-design-vue'
import { UserManagementAPI } from '../../../../services/axios/istry/pathwayService'

export default {
  name: 'VbResetPassword',

  setup() {
    const route = useRoute()
    const router = useRouter()
    const loading = ref(false)
    const token = ref('')

    onMounted(() => {
      // Get token from URL parameters
      token.value = route.query.token || ''
      if (!token.value) {
        notification.error({
          message: 'Invalid Reset Link',
          description: 'The reset password link is invalid or has expired.',
        })
        router.push({ name: 'lupa-password' })
      }
    })

    const resetForm = reactive({
      newPassword: '',
      confirmPassword: '',
    })

    const rules = {
      newPassword: [
        {
          required: true,
          message: 'Please input your new password!',
          trigger: 'change',
        },
        {
          min: 6,
          message: 'Password must be at least 6 characters!',
          trigger: 'change',
        },
      ],
      confirmPassword: [
        {
          required: true,
          message: 'Please confirm your password!',
          trigger: 'change',
        },
        {
          validator: (rule, value) => {
            if (value && value !== resetForm.newPassword) {
              return Promise.reject('Passwords do not match!')
            }
            return Promise.resolve()
          },
          trigger: 'change',
        },
      ],
    }

    const forgotForm = reactive({
      email: '',
    })
    const loginForm = reactive({
      email: '',
    })

    const handleFinish = async values => {
      try {
        loading.value = true
        await UserManagementAPI.resetPassword(token.value, values.newPassword)

        notification.success({
          message: 'Password Reset Successful',
          description:
            'Your password has been successfully reset. Please login with your new password.',
          duration: 5,
        })

        // Redirect to login page after successful reset
        setTimeout(() => {
          router.push({ name: 'masuk' })
        }, 2000)
      } catch (error) {
        notification.error({
          message: 'Password Reset Failed',
          description:
            error.response?.data?.message ||
            'Failed to reset password. The link may be expired or invalid.',
          duration: 5,
        })
      } finally {
        loading.value = false
      }
    }

    const handleFinishFailed = errorInfo => {
      console.log('Failed:', errorInfo)
    }

    return {
      rules,
      forgotForm,
      loginForm,
      resetForm,
      loading,
      handleFinish,
      handleFinishFailed,
    }
  },
}
</script>
<style lang="scss" module>
@import '@/@vb/components/Auth/style.module.scss';
</style>
